import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { StoreLayout } from './components/StoreLayout';
import { Home } from './pages/Home';
import { Catalog } from './pages/Catalog';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { Account } from './pages/Account';
import { Admin } from './pages/Admin';
import { Login } from './pages/Login';
export function App() {
  return <CartProvider data-id="element-0" data-mp="2mndna7xolord">
      <BrowserRouter data-id="element-1" data-mp="2mjzmh44o1nm1">
        <Routes data-id="element-2" data-mp="31agoaol7qfjg">
          <Route element={<StoreLayout data-id="element-4" data-mp="31brz38d2snk2" />} data-id="element-3" data-mp="31ayrk56alu0v">
            <Route path="/" element={<Home data-id="element-6" data-mp="2wk0b95lb0vxm" />} data-id="element-5" data-mp="31c1l6kv02akh" />
            <Route path="/productos" element={<Catalog data-id="element-8" data-mp="2wiffxdr618yp" />} data-id="element-7" data-mp="2wjgu3r3habkn" />
            <Route path="/producto/:slug" element={<ProductDetail data-id="element-10" data-mp="28tmex2vosax8" />} data-id="element-9" data-mp="2wi5mthatqlos" />
            <Route path="/mis-pedidos" element={<Account data-id="element-12" data-mp="23vciyq2516ak" />} data-id="element-11" data-mp="28suw6sn6u7od" />
            <Route path="/carrito" element={<Cart data-id="element-14" data-mp="23utcc5hxu4bu" />} data-id="element-13" data-mp="23vul23bheeqe" />
            <Route path="/checkout" element={<Checkout data-id="element-16" data-mp="3ik7k0rkruvvx" />} data-id="element-15" data-mp="23t8g8bfz6dbv" />
          </Route>
          <Route path="/login" element={<Login data-id="element-18" data-mp="3ii4ro0w5cqo1" />} data-id="element-17" data-mp="3ijfv1zlojwem" />
          <Route path="/admin" element={<Admin data-id="element-20" data-mp="3mkhou0wtvg97" />} data-id="element-19" data-mp="3mlat8v8bdto6" />
        </Routes>
      </BrowserRouter>
    </CartProvider>;
}